module.exports = __webpack_public_path__ + "assets/img/home-page.34f1f096.svg";